import type { IconSvgObject } from './types';

const PictureInPictureExitIcon: IconSvgObject = [
  ["path", { d: "M10.5 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H19.9999C21.1045 4 21.9999 4.89543 21.9999 6V10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 15C14 14.4477 14.4477 14 15 14H21C21.5523 14 22 14.4477 22 15V19C22 19.5523 21.5523 20 21 20H15C14.4477 20 14 19.5523 14 19V15Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 13L6.39125 8.39125M6.00036 11.5078L6 8L9.48896 8.00004", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PictureInPictureExitIcon;
